



































import { Component, Prop, Vue } from 'vue-property-decorator'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { InputInterface } from '../types/Exa_Input'

@Component({
    components: {
        FontAwesomeIcon
    }
})
export default class InputRadio extends Vue {
    @Prop() private libelle!: string
    @Prop() private description!: string
    @Prop() private value!: any
    @Prop() private data!: { options: Array<{ value: number; libelle: string; ordre: number }> }
    @Prop() private ident!: any
    @Prop() private requis!: boolean
    @Prop() private disabled!: boolean
    @Prop() mode_lecture!: boolean
    @Prop() condition!: InputInterface
    @Prop({ default: false }) check_validation!: boolean

    /** 
     * inputHandler 
     * Gère les événements de saisie de l'input en émettant un événement avec les données appropriées. 
     * @param {any} e - L'événement de saisie. 
     */
    inputHandler(e: any) {
        this.$emit('input', { ident: this.ident, value: e.target.value })
    }

    /**
     * getOptionLibelle
     * Récupère le libellé de l'option correspondant à une valeur donnée.
     * @param option_value La valeur de l'option dont on souhaite obtenir le libellé.
     * @returns Le libellé de l'option correspondant à la valeur donnée. Si aucun libellé n'est trouvé, la valeur d'option est retournée.
     */
    getOptionLibelle(option_value: any) {
        for (let i = 0; i < this.data.options.length; i++) {
            if (String(this.data.options[i].value) === String(option_value)) {
                return this.data.options[i].libelle
            }
        }
        return option_value
    }
}
